export default "/static/media/b7d8385eab49a94e1fb93180fa97cec7.png";